import StudentQuizzes from "layouts/StudentQuizzes";
import QuizByCode from "layouts/QuizByCode";
import StudentQuizResults from "layouts/StudentQuizResults";
import Titles from "layouts/titles";
import ShowTile from "layouts/titles/showTile/index";
import ShowThreeD from "layouts/titles/ShowThreeD";
import ShowQuestions from "layouts/quizTitles/ShowQuestions";
import AIHistory from "layouts/AIHistory";
import CommunityPage from "layouts/community";
import StudyHubHome from "layouts/studyHub/StudyHubHome";
import StudyPlanCreate from "layouts/studyHub/StudyPlanCreate";
import StudyPlanPage from "layouts/studyHub/StudyPlanPage";
import StudyLessonPage from "layouts/studyHub/StudyLessonPage";
import MicrolabCopilotHub from "layouts/microlabCopilot";
import MicrolabCopilotProcessing from "layouts/microlabCopilot/ProcessingScreen";
import MicrolabCopilotStudyPack from "layouts/microlabCopilot/StudyPackScreen";
import Icon from "@mui/material/Icon";
import { Navigate } from "react-router-dom";

const studentRoutes = [
  {
    type: "collapse",
    name: "Study Hub",
    key: "study",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/study",
    component: <StudyHubHome />,
  },
  {
    name: "study-all",
    key: "study-all",
    route: "/study/all",
    component: <StudyHubHome showAll />,
  },
  {
    name: "study-new",
    key: "study-new",
    route: "/study/new",
    component: <StudyPlanCreate />,
  },
  {
    name: "study-plan",
    key: "study-plan",
    route: "/study/plan/:planId",
    component: <StudyPlanPage />,
  },
  {
    name: "study-lesson",
    key: "study-lesson",
    route: "/study/plan/:planId/topic/:topicId",
    component: <StudyLessonPage />,
  },
  {
    type: "collapse",
    name: "Microlab Copilot",
    key: "microlab-copilot",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/microlab-copilot",
    component: <MicrolabCopilotHub />,
  },
  {
    type: "collapse",
    name: "Histology",
    key: "histology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/histology",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryology",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },
  {
    name: "threeDTitles",
    key: "threeD",
    route: "/threeDTitles",
    component: <Navigate to="/histology?segment=models" replace />,
  },
  {
    type: "collapse",
    name: "Anatomy",
    key: "anatomy",
    icon: <Icon fontSize="small">accessibility_new</Icon>,
    route: "/anatomyTitles",
    component: <Titles type="anatomy" readOnly />,
  },
  {
    type: "collapse",
    name: "Mock Quiz",
    key: "my-quizzes",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/my-quizzes",
    component: <StudentQuizzes />,
  },
  {
    type: "collapse",
    name: "University Quiz",
    key: "mock-quiz",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/mock-quiz",
    component: <QuizByCode />,
  },
  {
    type: "collapse",
    name: "Results",
    key: "student-quiz-results",
    icon: <Icon fontSize="small">assessment</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Mock Results",
        key: "mock-results",
        route: "/quiz-results/mock",
        component: <StudentQuizResults kind="mock" />,
      },
      {
        type: "collapse",
        name: "University Results",
        key: "university-results",
        route: "/quiz-results/university",
        component: <StudentQuizResults kind="university" />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Community",
    key: "community",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/community",
    component: <CommunityPage />,
  },
  {
    type: "collapse",
    name: "AI History",
    key: "ai-history",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/ai-history",
    component: <AIHistory />,
  },
  {
    name: "quiz-by-code",
    key: "quiz-by-code",
    route: "/quiz-by-code",
    component: <QuizByCode />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
  // Microlab Copilot hidden routes (no sidebar entry).
  {
    name: "microlabCopilotProcessing",
    key: "microlabCopilotProcessing",
    route: "/microlab-copilot/processing/:materialId",
    component: <MicrolabCopilotProcessing />,
  },
  {
    name: "microlabCopilotStudyPack",
    key: "microlabCopilotStudyPack",
    route: "/microlab-copilot/study/:materialId",
    component: <MicrolabCopilotStudyPack />,
  },
];

export default studentRoutes;
